import { ShoppingBag } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ProductListProps {
  interactiveData: any
}

export function ProductList({ interactiveData }: ProductListProps) {
  const sections = interactiveData.sections || []
  const totalItems = interactiveData.total_items || 0
  const headerText = interactiveData.header_text || 'Our Products'
  const bodyText = interactiveData.body_text || ''
  const footerText = interactiveData.footer_text || ''

  return (
    <div
      className="max-w-sm min-w-0"
      style={{ fontFamily: 'var(--wn-font)' }}
      data-testid="inbox-product-list-card"
    >
      {bodyText && (
        <div
          className="break-words whitespace-pre-wrap"
          style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 500, color: '#101828' }}
          data-testid="inbox-product-list-body"
        >
          {bodyText}
        </div>
      )}

      <div
        className={cn(
          'flex items-start gap-2.5 pb-2.5 border-b border-[#edf1f7]',
          bodyText && 'mt-2.5',
        )}
      >
        <div
          className="h-9 w-9 rounded-[10px] flex items-center justify-center shrink-0"
          style={{ background: '#E8F8F0' }}
        >
          <ShoppingBag className="h-4 w-4" style={{ color: '#1EB677' }} />
        </div>
        <div className="flex-1 min-w-0">
          <div
            className="truncate"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}
          >
            {headerText}
          </div>
          <div
            className="truncate mt-0.5"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
          >
            {totalItems} {totalItems === 1 ? 'item' : 'items'}
          </div>
        </div>
      </div>

      {sections.length > 0 && (
        <div className="mt-2.5 space-y-1.5">
          {sections.map((section: any, sectionIndex: number) => {
            const count = section.product_items?.length || 0
            return (
              <div
                key={sectionIndex}
                className="rounded-[10px] p-2.5 min-w-0"
                style={{ background: '#fbfcfd', border: '1px solid #edf1f7' }}
              >
                <div
                  className="truncate"
                  style={{ fontFamily: 'var(--wn-font)', fontSize: 12, fontWeight: 600, color: '#101828' }}
                >
                  {section.title || 'Products'}
                </div>
                <div
                  className="mt-0.5"
                  style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
                >
                  {count} {count === 1 ? 'product' : 'products'}
                </div>
              </div>
            )
          })}
        </div>
      )}

      {footerText && (
        <div
          className="mt-2 break-words"
          style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
        >
          {footerText}
        </div>
      )}

      <div className="mt-3 pt-2.5 border-t border-[#edf1f7]">
        <button
          type="button"
          className="w-full rounded-[8px] py-2 px-4 transition-opacity hover:opacity-90"
          style={{
            background: '#1EB677',
            color: '#FFFFFF',
            fontFamily: 'var(--wn-font)',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          View items
        </button>
      </div>
    </div>
  )
}
